import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../author/author.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";

const addEndpoint = ApiEndpoints.clientLogo.Create;

export default function AddClientLogo() {
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const [formData, setFormData] = useState({
    country: "",
    alt_logo:"",
    logo: null,
  });

  const handleChange = useCallback((event) => {
    const { name, value, type, files } = event.target;

    if (name === "logo" && type === "file") {
      const file = files[0];
      if (file) {
        const objectUrl = URL.createObjectURL(file);
        setPreviewImage(objectUrl);
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "file" ? files[0] : value,
    }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();

      // Create a new FormData instance
      const payload = new FormData();

      // Add all form fields except the image
      Object.keys(formData).forEach((key) => {
        if (key !== "logo") {
          payload.append(key, formData[key]);
        }
      });

      // Append the image field if it exists
      if (formData.logo) {
        payload.append("logo", formData.logo);
      }

      try {
        // Send the API request with the FormData payload
        const response = await ApiRequest("POST", addEndpoint, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        if (response.error === true) {
          toast.error(response.message)
        } else {
          toast.success(response.message)
          navigate("/admin/client-logos");
        }
      } catch (error) {
        console.error("Error updating logo:", error);
      }
    },
    [formData, navigate]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Add Client Logo</h5>
      </div>

      <div className="add-author-content">
        <form onSubmit={handleSubmit}>
          <label>Country*:</label>
          <input type="text" name="country" value={formData.country} onChange={handleChange} required className="form-control" />

          <label>Image (344 x  200 px)*:</label>
          <input type="file" name="logo" accept=".webp" onChange={handleChange} className="form-control" required />
          {previewImage && (
            <div style={{ width: "60px", height: "60px", margin: "10px 0", overflow: "hidden" }}>
              <img src={previewImage} alt="Preview" className="img-responsive" />
            </div>
          )}

          <label>Alt Image*:</label>
          <input type="text" name="alt_logo" onChange={handleChange} className="form-control" required />

          <div className="submit-formbtn mt-4">
            <button type="submit" className="default-btn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
